import React, { Suspense, lazy, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "./Components/Sidebar";
import { ThemeProvider } from "./context/ThemeContext";
import Loader from "./Components/Loader";
import Languages from "./Pages/Languages";
import Genres from "./Pages/Genres";
import Source from "./Pages/Source";
import ContentType from "./Pages/ContentType";
import MovieForm from "./Components/MovieForm";
import MovieRowForm from "./Components/MoviePage";
import RowForm from "./Components/MovieRowForm";
import SourceCreate from "./Components/Source";
import GenreForm from "./Components/Genres";
import LanguageForm from "./Components/Languages";
import ContentTypeForm from "./Components/ContentType";
import Directors from "./Pages/Directors";
import DirectorForm from "./Components/Directors";
import CastMembers from "./Pages/castMembers";
import CastMemberForm from "./Components/CastMembers";
import Cookies from "js-cookie";
import LoginPage from "./Pages/Auth/LoginPage";
import Year from "./Pages/Year";
import YearForm from "./Components/Year";
import Scheduling from "./Pages/Scheduling";
import SchedulingForm from "./Components/Scheduling";

import AnalyticsPage from "./Pages/Analytics/Analytics";
import CreateSessionUI from "./Pages/SessionUI";
import Brand from "./Pages/Brand";
import BrandForm from "./Components/Brand";
import Vendor from "./Pages/Vendor";
import Factory from "./Pages/Factory";
import VendorForm from "./Components/Vendor";
import FactoryForm from "./Components/Factory";
import RecentTiles from "./Pages/RecentTiles";


// import AnalyticsPage from "./Pages/Analytics/Analytics";

const TileCreate = lazy(() => import("./Pages/Tile/TileList"));
const RowCreate = lazy(() => import("./Pages/Row"));
const PageCreate = lazy(() => import("./Pages/MainPage/MainPage"));
const ViewMovie = lazy(() => import("./Components/TVLandingPage/index"));

// 🔒 Private route wrapper
const PrivateRoute = ({ children }) => {
  const token = Cookies.get("authToken");
  return token ? children : <Navigate to="/login" />;
};

function App() {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ThemeProvider>
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<LoginPage />} />

                              <Route
  path="/architecture"
  element={
    <div style={{ height: "100vh" }}>
      <iframe
        src="/architecture.html"
        title="Architecture"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  }
/>

        {/* Protected dashboard routes */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <div className="flex h-screen overflow-hidden cw-bg">
                <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
                <div
                  className={`flex-1 overflow-auto transition-all duration-300 ease-in-out cw-bg ${
                    isOpen ? "md:ml-60" : "md:ml-16"
                  }`}
                >
                  <Suspense fallback={<Loader />}>
                    <Routes>
                      <Route path="/" element={<PageCreate />} />
                      <Route path="/page" element={<MovieRowForm />} />
                      <Route path="/page/:id" element={<MovieRowForm />} />
                      <Route path="/viewpage/:id" element={<ViewMovie />} />



                      <Route path="/tile" element={<TileCreate />} />
                      <Route path="/tile/create" element={<MovieForm />} />
                      <Route path="/tile/:id" element={<MovieForm />} />

                      <Route path="/recent-tiles" element={<RecentTiles />} />


                    



                      <Route path="/row" element={<RowCreate />} />
                      <Route path="/row/create" element={<RowForm />} />
                      <Route path="/row/:id" element={<RowForm />} />



                      <Route path="/source" element={<Source />} />
                      <Route path="/source/create" element={<SourceCreate />} />
                      <Route path="/source/:id" element={<SourceCreate />} />



                      <Route path="/genres" element={<Genres />} />
                      <Route path="/genres/create" element={<GenreForm />} />
                      <Route path="/genres/:id" element={<GenreForm />} />



                      <Route path="/languages" element={<Languages />} />
                      <Route path="/languages/create" element={<LanguageForm />} />
                      <Route path="/languages/:id" element={<LanguageForm />} />


                      <Route path="/content-type" element={<ContentType />} />
                      <Route
                        path="/content-type/create"
                        element={<ContentTypeForm />}
                      />
                      <Route
                        path="/content-type/:id"
                        element={<ContentTypeForm />}
                      />



                      <Route path="/directors" element={<Directors />} />
                      <Route path="/directors/create" element={<DirectorForm />} />
                      <Route path="/directors/:id" element={<DirectorForm />} />



                      <Route path="/cast-members" element={<CastMembers />} />


                      <Route path="/year" element={<Year />} />
                      <Route path="/year/create" element={<YearForm />} />
                      <Route path="/year/:id" element={<YearForm />} />


                      <Route path="/scheduling" element={<Scheduling />} />
                      <Route path="/scheduling/create" element={<SchedulingForm />} />
                      <Route path="/scheduling/:id" element={<SchedulingForm />} />


                      <Route
                        path="/cast-members/create"
                        element={<CastMemberForm />}
                      />
                      <Route
                        path="/cast-members/:id"
                        element={<CastMemberForm />}
                      />

                      {/* <Route path="/analytics" element={<AnalyticsPage />} /> */}


                      <Route path="/session-ui" element={<CreateSessionUI />} />

                       <Route path="/brand" element={<Brand />} />
                      <Route path="/brand/create" element={<BrandForm />} />
                      <Route path="/brand/:id" element={<BrandForm />} />

                      <Route path="/vendor" element={<Vendor />} />
                      <Route path="/vendor/create" element={<VendorForm />} />
                      <Route path="/vendor/:id" element={<VendorForm />} />

                      <Route path="/factory" element={<Factory />} />
                      <Route path="/factory/create" element={<FactoryForm />} />
                      <Route path="/factory/:id" element={<FactoryForm />} />




                    </Routes>
                  </Suspense>
                </div>
              </div>
            </PrivateRoute>
          }
        />
      </Routes>
    </Suspense>
    </ThemeProvider>
  );
}

export default App;
